import { Box, CircularProgress } from "@mui/material";
import { GetPersonalFavoriteListResponse, useGetApiAccountFavoritesQuery } from "api/generatedApi";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { FavListBreadcrumbNav } from "./favorite-list-components/breadcrumb-nav";
import { useScreenSize, ScreenSizeEnum } from "shared/use-screen-size";
import { DesktopItemList } from "./favorite-list-components/desktop/desktop-item-list";
import { MobileListList } from "./favorite-list-components/mobile/mobile-list-list";
import { DesktopListList } from "./favorite-list-components/desktop/desktop-list-list";
import { MobileItemList } from "./favorite-list-components/mobile/mobile-item-list";

export const FavoritesPage = () => {
  const { data: favoriteLists, isLoading } = useGetApiAccountFavoritesQuery();

  // 1: List View, 2: Item List View
  const [viewState, setViewState] = useState<number>(1);
  const [currentListId, setCurrentListId] = useState<string>("");
  const [choosenList, setChoosenList] = useState<GetPersonalFavoriteListResponse | undefined>(undefined);
  const { screenSize } = useScreenSize();

  const { t } = useTranslation();

  useEffect(() => {
    setChoosenList(favoriteLists?.lists?.find((list) => list.id === currentListId));
  }, [favoriteLists]);

  const handleViewChangeClick = (itemId: string) => {
    if (viewState == 1) {
      const selectedList = favoriteLists?.lists?.find((list) => list.id === itemId);
      if (selectedList?.id) {
        setCurrentListId(selectedList.id);
        setChoosenList(selectedList);
        setViewState(2);
      }
    } else setViewState(1);
  };

  if (!isLoading) console.log("loading finished: ", favoriteLists);

  if (!favoriteLists || isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100%">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <FavListBreadcrumbNav from={t("account.favorites.breadcrumbTitle")} here={choosenList?.name} setViewState={setViewState} viewState={viewState} />

      {viewState === 1 && (
        <Box padding={3} display="flex" flexDirection="column" gap={2}>
          {screenSize === ScreenSizeEnum.Mobile ? <MobileListList favoriteLists={favoriteLists} onItemClick={handleViewChangeClick} /> : <DesktopListList favoriteLists={favoriteLists} onItemClick={handleViewChangeClick} />}
        </Box>
      )}
      <Box padding={3} display="flex" flexDirection="column" gap={2}>
        {viewState === 2 && <>{screenSize === ScreenSizeEnum.Mobile ? <MobileItemList favoriteList={choosenList} /> : <DesktopItemList favoriteList={choosenList} />}</>}
      </Box>
    </Box>
  );
};
